<div class="list-input-container" (click)="focusInput($event)">
  <ng-container *ngFor="let item of itemList; let i = index">
    <div class="list-item" [ngClass]="{ invalid: !validateItem(item), frozen: frozen }">
      {{ item }}
      <button *ngIf="!frozen" class="delete-button" type="button" (click)="removeItem(i)">
        <i class="fa-utility fa-semibold fa-xmark"></i>
      </button>
    </div>
  </ng-container>
  <input
    id="handle-inp"
    #inputField
    class="spacer"
    type="text"
    [(ngModel)]="currentItem"
    (keydown)="handleKeyDown($event)"
    (paste)="handleClipboardPaste($event)"
    [placeholder]="itemList.length > 0 ? '' : placeholderText"
    (blur)="addItem()"
    [disabled]="this.frozen"
  />
</div>
